export enum RepCardActions {
    ACCORDION_TOGGLE = 0,
    SHOW_MORE_TOGGLE,
}
